import React from 'react';
import ButtonStyles from './Button.module.css';

const Button = ({ varient = 'primary', label, icon, onClick, style }) => {
	return (
		<button
			className={varient === 'primary' ? ButtonStyles.button : varient === 'danger' && ButtonStyles.button__delete}
			style={style}
			onClick={onClick}>
			{label}
			<svg className={ButtonStyles.button__icon}>
				<use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
			</svg>
		</button>
	);
};

export const ButtonPrefix = ({ varient = 'primary', label, icon, onClick, style }) => {
	return (
		<button
			className={varient === 'primary' ? ButtonStyles.button : varient === 'danger' && ButtonStyles.button__delete}
			style={style}
			onClick={onClick}> 
			<svg className={ButtonStyles.button__icon}>
				<use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
			</svg>  
			{label}
		</button>
	);
};


export default Button;
